import { unzip as fflateUnzip } from "fflate";
import JSZip from "jszip";

export async function unzip(zippedData: any, isJson = true, signal?: AbortSignal) {
  if (signal?.aborted) {
    throw new DOMException("Aborted", "AbortError");
  }
  if (isJson) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      fflateUnzip(new Uint8Array(zippedData), async (err, files) => {
        if (err) {
          return reject(err);
        }
        if (signal?.aborted) {
          return reject(new DOMException("Aborted", "AbortError"));
        }

        const worker = new Worker(new URL("./jsonParserWorker.js", import.meta.url), {
          type: "module",
        });

        const onAbort = () => {
          worker.terminate();
          reject(new DOMException("Aborted", "AbortError"));
        };
        signal?.addEventListener("abort", onAbort, { once: true });

        worker.postMessage(files["data"]);

        worker.onmessage = (event) => {
          signal?.removeEventListener("abort", onAbort);
          if (event.data.error) {
            worker.terminate();
            reject(event.data.error);
          } else {
            worker.terminate();
            resolve(event.data.result);
          }
        };

        worker.onerror = (error) => {
          signal?.removeEventListener("abort", onAbort);
          worker.terminate();
          reject(`Worker error: ${error.message}`);
        };
      });
    });
  } else {
    const zip = new JSZip();
    const loadedZip = await zip.loadAsync(zippedData);
    const file = Object.values(loadedZip.files)[0];

    const fileContent = await file?.async("uint8array");
    const base64String = new TextDecoder().decode(fileContent);

    return base64String;
  }
}
